import { FleetStats } from ".."
import { MockFleetEntry, generateFleetEntries } from "../types.test.helper"

const entries: Array<MockFleetEntry> = [
  {
    vehicleId: `7771df18-7aad-11eb-9745-538568c53d2c`,
    make: `Audi`,
    registrationNumber: `LM55APB`,
    model: `A2 SE`,
    onCoverDate: `2022-01-07`,
    offCoverDate: `2022-03-01`,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `SE`,
    nominalStartYear: 2000,
    status: `off_cover`,
  },
  {
    vehicleId: `7771df18-7aad-11eb-9745-538568c53d2c`,
    make: `Audi`,
    registrationNumber: `LM55APB`,
    model: `A2 SE`,
    onCoverDate: `2022-03-04`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `SE`,
    nominalStartYear: 2000,
    status: `on_cover`,
  },
  {
    vehicleId: `60d85be6-7abd-11eb-9745-fbd5bc301af6`,
    make: `Renault`,
    registrationNumber: `YH21 WWD`,
    model: `Master LL35 Business`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-01-20`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `LL35 Business`,
    nominalStartYear: 2019,
    status: `off_cover`,
  },
  {
    vehicleId: `60d85be6-7abd-11eb-9745-fbd5bc301af6`,
    make: `Renault`,
    registrationNumber: `YH21 WWD`,
    model: `Master LL35 Business`,
    onCoverDate: `2022-01-28`,
    offCoverDate: `2022-01-31`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `LL35 Business`,
    nominalStartYear: 2019,
    status: `off_cover`,
  },
  {
    vehicleId: `60d85be6-7abd-11eb-9745-fbd5bc301af6`,
    make: `Renault`,
    registrationNumber: `YH21WWD`,
    model: `Master LL35 Business`,
    onCoverDate: `2022-03-04`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `LL35 Business`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `cc4de6e2-1a2d-11ec-8f69-23a7487d6ffd`,
    make: `Audi`,
    registrationNumber: `AV71 SGU`,
    model: `Q3 PHEV Black Edition`,
    onCoverDate: `2021-11-24`,
    offCoverDate: `2022-01-26`,
    sentToMID: `2021-11-30 00:31:44.965747+00`,
    fuelType: `petrol`,
    trim: `Black Edition`,
    nominalStartYear: 2021,
    status: `off_cover`,
  },
  {
    vehicleId: `cc4de6e2-1a2d-11ec-8f69-23a7487d6ffd`,
    make: `Audi`,
    registrationNumber: `AV71 SGU`,
    model: `Q3 PHEV Black Edition`,
    onCoverDate: `2022-03-01`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Black Edition`,
    nominalStartYear: 2021,
    status: `on_cover`,
  },
  {
    vehicleId: `93e76468-7ab9-11eb-9745-f31cffd95576`,
    make: `MAN`,
    registrationNumber: `OW21 DHU`,
    model: `TGE 3.140`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-04-30`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `3.140`,
    nominalStartYear: 2017,
    status: `on_cover`,
  },
  {
    vehicleId: `93e76468-7ab9-11eb-9745-f31cffd95576`,
    make: `MAN`,
    registrationNumber: `OW21 DHO`,
    model: `TGE 3.140`,
    onCoverDate: `2021-11-15`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `3.140`,
    nominalStartYear: 2017,
    status: `on_cover`,
  },
  {
    vehicleId: `93e76468-7ab9-11eb-9745-f31cffd95576`,
    make: `MAN`,
    registrationNumber: `OW21 DHP`,
    model: `TGE 3.140`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-01-15`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `3.140`,
    nominalStartYear: 2017,
    status: `off_cover`,
  },
  {
    vehicleId: `ffb87f18-7abb-11eb-9745-dff9e1d6ea3d`,
    make: `Peugeot`,
    registrationNumber: `SB19 RVL`,
    model: `3008 Allure`,
    onCoverDate: `2021-11-15`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `Allure`,
    nominalStartYear: 2016,
    status: `on_cover`,
  },
  {
    vehicleId: `a6cb7c64-7ab8-11eb-9745-0bb076bc1cd3`,
    make: `Mercedes-Benz`,
    registrationNumber: `L111 DHC`,
    model: `GLC Class 250 AMG Line Premium`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-01-13`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `250 AMG Line Premium`,
    nominalStartYear: 2015,
    status: `off_cover`,
  },
  {
    vehicleId: `8069ecf4-7abd-11eb-9745-73860300947d`,
    make: `Renault`,
    registrationNumber: `PO16 EZD`,
    model: `Master 135.35`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-01-21`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `135.35`,
    nominalStartYear: 2014,
    status: `off_cover`,
  },
  {
    vehicleId: `8069ecf4-7abd-11eb-9745-73860300947d`,
    make: `Renault`,
    registrationNumber: `PO16 EZF`,
    model: `Master 135.35`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2021-12-08`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `135.35`,
    nominalStartYear: 2014,
    status: `off_cover`,
  },
  {
    vehicleId: `99a77fb8-7aba-11eb-9745-bb85ef8ccb7c`,
    make: `Nissan`,
    registrationNumber: `YN17 LSF`,
    model: `NV400 SE L3 Single Cab`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-02-28`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `SE L3 Single Cab`,
    nominalStartYear: 2014,
    status: `off_cover`,
  },
  {
    vehicleId: `7dec27da-7abd-11eb-9745-3b205bf1f7b1`,
    make: `Renault`,
    registrationNumber: `BT70 KOD`,
    model: `Master LL35`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2021-12-18`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `LL35`,
    nominalStartYear: 2019,
    status: `off_cover`,
  },
  {
    vehicleId: `a2550630-7ab0-11eb-9745-a31bd3e0dd1d`,
    make: `Citroen`,
    registrationNumber: `LC70 AFN`,
    model: `Relay 35 Heavy L4H2 Enterprise`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-02-16`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `35 Heavy L4H2 Enterprise`,
    nominalStartYear: 2014,
    status: `off_cover`,
  },
  {
    vehicleId: `a2550630-7ab0-11eb-9745-a31bd3e0dd1d`,
    make: `Citroen`,
    registrationNumber: `LC70 AFN`,
    model: `Relay 35 Heavy L4H2 Enterprise`,
    onCoverDate: `2022-02-17`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `35 Heavy L4H2 Enterprise`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `e2f3dbf6-7abc-11eb-9745-27536aea107a`,
    make: `Renault`,
    registrationNumber: `YR65 JTU`,
    model: `Trafic LL29 Sport`,
    onCoverDate: `2021-11-15`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `LL29 Sport`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `5dd6e046-7ab0-11eb-9745-47748b324423`,
    make: `Citroen`,
    registrationNumber: `YF67 RZM`,
    model: `Berlingo L1 625 Enterprise`,
    onCoverDate: `2021-11-15`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `L1 625 Enterprise`,
    nominalStartYear: 2015,
    status: `on_cover`,
  },
  {
    vehicleId: `b7e43032-7ab2-11eb-9745-6fd31ed8af1f`,
    make: `Ford`,
    registrationNumber: `BT70TUA`,
    model: `Transit Custom 300 Limited L1H1`,
    onCoverDate: `2022-05-15`,
    offCoverDate: `2022-11-15`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `300 Limited L1H1`,
    nominalStartYear: 2018,
    status: `scheduled`,
  },
  {
    vehicleId: `6b84cc96-7abd-11eb-9745-ab07cf054969`,
    make: `Renault`,
    registrationNumber: `WP70CKA`,
    model: `ZOE i GT Line Rapid Charge`,
    onCoverDate: `2021-11-15`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `electric`,
    trim: `i GT Line Rapid Charge`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `4f6f4ca2-7aae-11eb-9745-4fa9ca608562`,
    make: `Audi`,
    registrationNumber: `WP70CLC`,
    model: `A4 Allroad`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-02-10`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `Allroad`,
    nominalStartYear: 2008,
    status: `off_cover`,
  },
  {
    vehicleId: `d48bf6a2-7aad-11eb-9745-971909d39eb4`,
    make: `Audi`,
    registrationNumber: `WP70CKB`,
    model: `A1 Amplified Edition`,
    onCoverDate: `2021-11-15`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `Amplified Edition`,
    nominalStartYear: 2010,
    status: `on_cover`,
  },
  {
    vehicleId: `7be98aaa-7aad-11eb-9745-ffcacacf3ea1`,
    make: `Audi`,
    registrationNumber: `WP70CLD`,
    model: `A3 Black Edition`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-02-14`,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Black Edition`,
    nominalStartYear: 2008,
    status: `off_cover`,
  },
  {
    vehicleId: `7be98aaa-7aad-11eb-9745-ffcacacf3ea1`,
    make: `Audi`,
    registrationNumber: `WP70CLD`,
    model: `A3 Black Edition`,
    onCoverDate: `2022-03-21`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Black Edition`,
    nominalStartYear: 2008,
    status: `on_cover`,
  },
  {
    vehicleId: `6b84cc96-7abd-11eb-9745-ab07cf054969`,
    make: `Renault`,
    registrationNumber: `WP70CKE`,
    model: `ZOE i GT Line Rapid Charge`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-10-19`,
    sentToMID: null,
    fuelType: `electric`,
    trim: `i GT Line Rapid Charge`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `6b84cc96-7abd-11eb-9745-ab07cf054969`,
    make: `Renault`,
    registrationNumber: `WP70CKG`,
    model: `ZOE i GT Line Rapid Charge`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-10-19`,
    sentToMID: null,
    fuelType: `electric`,
    trim: `i GT Line Rapid Charge`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `6358baf2-7ab6-11eb-9745-9bbea83df236`,
    make: `Jaguar`,
    registrationNumber: `716BAD`,
    model: `E-Pace R-Dynamic SE`,
    onCoverDate: `2021-12-12`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `R-Dynamic SE`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `6b84cc96-7abd-11eb-9745-ab07cf054969`,
    make: `Renault`,
    registrationNumber: `WP70CKF`,
    model: `ZOE i GT Line Rapid Charge`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-10-19`,
    sentToMID: null,
    fuelType: `electric`,
    trim: `i GT Line Rapid Charge`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `6b84cc96-7abd-11eb-9745-ab07cf054969`,
    make: `Renault`,
    registrationNumber: `WP70CKJ`,
    model: `ZOE i GT Line Rapid Charge`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-10-19`,
    sentToMID: null,
    fuelType: `electric`,
    trim: `i GT Line Rapid Charge`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `e7068130-7ac1-11eb-9745-3b2fe67ee7a6`,
    make: `Volkswagen`,
    registrationNumber: `GJ70 XTM`,
    model: `Crafter Trendline 35`,
    onCoverDate: `2021-12-20`,
    offCoverDate: null,
    sentToMID: `2021-12-21 00:32:01.442296+00`,
    fuelType: `diesel`,
    trim: `Trendline 35`,
    nominalStartYear: 2017,
    status: `on_cover`,
  },
  {
    vehicleId: `10597108-7ab5-11eb-9745-6b56ac3f45a3`,
    make: `Vauxhall`,
    registrationNumber: `DN69 OTK`,
    model: `Vivaro Dynamic 2900 L2H1`,
    onCoverDate: `2021-12-20`,
    offCoverDate: null,
    sentToMID: `2021-12-21 00:32:01.450956+00`,
    fuelType: `diesel`,
    trim: `Dynamic 2900 L2H1`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `10597108-7ab5-11eb-9745-6b56ac3f45a3`,
    make: `Vauxhall`,
    registrationNumber: `DS69 EPU`,
    model: `Vivaro Dynamic 2900 L2H1`,
    onCoverDate: `2021-12-20`,
    offCoverDate: null,
    sentToMID: `2021-12-21 00:32:01.460854+00`,
    fuelType: `diesel`,
    trim: `Dynamic 2900 L2H1`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `b6b681d8-7ab2-11eb-9745-fb0d06c437d4`,
    make: `Ford`,
    registrationNumber: `BK19 WTJ`,
    model: `Transit Custom 300 L1H1`,
    onCoverDate: `2021-12-20`,
    offCoverDate: null,
    sentToMID: `2021-12-21 00:32:01.464855+00`,
    fuelType: `diesel`,
    trim: `300 L1H1`,
    nominalStartYear: 2018,
    status: `on_cover`,
  },
  {
    vehicleId: `51708010-7aaf-11eb-9745-1ff8c02a99ec`,
    make: `BMW`,
    registrationNumber: `ET15GXN`,
    model: `2 Series 228i M Sport`,
    onCoverDate: `2021-12-20`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `228i M Sport`,
    nominalStartYear: 2013,
    status: `on_cover`,
  },
  {
    vehicleId: `4b0cd660-7ab4-11eb-9745-6fbb442ee34e`,
    make: `Vauxhall`,
    registrationNumber: `DX15NPK`,
    model: `Astra Design`,
    onCoverDate: `2022-01-06`,
    offCoverDate: `2022-03-26`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `Design`,
    nominalStartYear: 2010,
    status: `off_cover`,
  },
  {
    vehicleId: `ef26d426-7aaf-11eb-9745-830018d6db04`,
    make: `Cagiva`,
    registrationNumber: `AB11CDE`,
    model: `Canyon 900IE`,
    onCoverDate: `2021-12-07`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `900IE`,
    nominalStartYear: 1996,
    status: `on_cover`,
  },
  {
    vehicleId: `337b94e2-7aae-11eb-9745-d7ba8ece2cef`,
    make: `Audi`,
    registrationNumber: `PO16 EZJ`,
    model: `A1 Sport`,
    onCoverDate: `2021-11-15`,
    offCoverDate: `2022-10-19`,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Sport`,
    nominalStartYear: 2018,
    status: `on_cover`,
  },
  {
    vehicleId: `b0766c44-7aac-11eb-9745-8f9f33109e43`,
    make: `Adiva`,
    registrationNumber: `LM55APR`,
    model: `e-Moving null`,
    onCoverDate: `2022-01-12`,
    offCoverDate: `2022-01-29`,
    sentToMID: null,
    fuelType: `electric`,
    trim: null,
    nominalStartYear: 2013,
    status: `off_cover`,
  },
  {
    vehicleId: `c0fe3b0a-7abb-11eb-9745-c34f2095e97b`,
    make: `Peugeot`,
    registrationNumber: `LM55APX`,
    model: `206 Verve`,
    onCoverDate: `2022-01-12`,
    offCoverDate: `2022-02-05`,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Verve`,
    nominalStartYear: 1998,
    status: `off_cover`,
  },
  {
    vehicleId: `745e5b98-7aae-11eb-9745-c74a6dc9084a`,
    make: `Audi`,
    registrationNumber: `YD21KKF`,
    model: `A3 e-tron S Line`,
    onCoverDate: `2022-01-13`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `S Line`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `96c0b760-7abf-11eb-9745-07d61bf41fdb`,
    make: `Toyota`,
    registrationNumber: `FE07HZY`,
    model: `Yaris T2`,
    onCoverDate: `2022-01-15`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `T2`,
    nominalStartYear: 2005,
    status: `on_cover`,
  },
  {
    vehicleId: `2eed2b0c-7aae-11eb-9745-d7f1f4acb3d3`,
    make: `Audi`,
    registrationNumber: `LM55APT`,
    model: `Q7 Black Edition Quattro`,
    onCoverDate: `2022-01-19`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `Black Edition Quattro`,
    nominalStartYear: 2015,
    status: `on_cover`,
  },
  {
    vehicleId: `80474be8-7abf-11eb-9745-e3efed00dc55`,
    make: `Toyota`,
    registrationNumber: `FE07HZU`,
    model: `Aygo Plus`,
    onCoverDate: `2022-01-24`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Plus`,
    nominalStartYear: 2005,
    status: `on_cover`,
  },
  {
    vehicleId: `aec0d47a-7aac-11eb-9745-d3d26b3ee039`,
    make: `AC`,
    registrationNumber: `DJ71RZK`,
    model: `16 null`,
    onCoverDate: `2022-01-26`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: null,
    nominalStartYear: 1933,
    status: `on_cover`,
  },
  {
    vehicleId: `28cd22ea-7abd-11eb-9745-534f03f616e3`,
    make: `Renault`,
    registrationNumber: `DJ71RZQ`,
    model: `Scenic Dynamique Nav`,
    onCoverDate: `2022-01-31`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Dynamique Nav`,
    nominalStartYear: 2016,
    status: `on_cover`,
  },
  {
    vehicleId: `3ff9c50e-7aae-11eb-9745-f78d78723821`,
    make: `Audi`,
    registrationNumber: `ET15GXQ`,
    model: `70 L`,
    onCoverDate: `2022-01-31`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `L`,
    nominalStartYear: 1966,
    status: `on_cover`,
  },
  {
    vehicleId: `4ad1bd82-7abe-11eb-9745-7f364d92c302`,
    make: `SEAT`,
    registrationNumber: `KO21CXP`,
    model: `Ateca SE Technology`,
    onCoverDate: `2022-01-10`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.411074+00`,
    fuelType: `petrol`,
    trim: `SE Technology`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `4e0c19f6-7abf-11eb-9745-2b51ead26bac`,
    make: `Suzuki`,
    registrationNumber: `KO21YHA`,
    model: `Vitara SZ-5 AllGrip`,
    onCoverDate: `2022-01-10`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.403981+00`,
    fuelType: `petrol`,
    trim: `SZ-5 AllGrip`,
    nominalStartYear: 2018,
    status: `on_cover`,
  },
  {
    vehicleId: `440b6ba0-1a2e-11ec-8f69-0fb69d75871d`,
    make: `Ford`,
    registrationNumber: `HT69NAA`,
    model: `Transit 350 Limited L3H2`,
    onCoverDate: `2022-01-10`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.433918+00`,
    fuelType: `diesel`,
    trim: `350 Limited L3H2`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `6624eb50-7abd-11eb-9745-5f6c1366cc71`,
    make: `Renault`,
    registrationNumber: `FG70VPE`,
    model: `Trafic SL28 Sport`,
    onCoverDate: `2022-01-11`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.36975+00`,
    fuelType: `diesel`,
    trim: `SL28 Sport`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `a21e17ba-7ab0-11eb-9745-a320b9dda540`,
    make: `Citroen`,
    registrationNumber: `OY69JXZ`,
    model: `Relay 35 L3H2 Enterprise`,
    onCoverDate: `2022-01-12`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.440857+00`,
    fuelType: `diesel`,
    trim: `35 L3H2 Enterprise`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `601dba8a-7ab2-11eb-9745-2324023aef7f`,
    make: `Ford`,
    registrationNumber: `GK66ZGL`,
    model: `Transit Minibus Trend L4H3`,
    onCoverDate: `2022-01-12`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.336133+00`,
    fuelType: `diesel`,
    trim: `Trend L4H3`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `d72bae9e-7ab6-11eb-9745-93a5217050f5`,
    make: `Kia`,
    registrationNumber: `PE71WPT`,
    model: `Sportage 2`,
    onCoverDate: `2022-01-11`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.442964+00`,
    fuelType: `diesel`,
    trim: `2`,
    nominalStartYear: 2018,
    status: `on_cover`,
  },
  {
    vehicleId: `601dba8a-7ab2-11eb-9745-2324023aef7f`,
    make: `Ford`,
    registrationNumber: `CP17BAU`,
    model: `Transit Minibus Trend L4H3`,
    onCoverDate: `2022-01-11`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.445142+00`,
    fuelType: `diesel`,
    trim: `Trend L4H3`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `dd4617ba-7ab6-11eb-9745-0388b07fae08`,
    make: `Kia`,
    registrationNumber: `HT21KWK`,
    model: `XCeed 3`,
    onCoverDate: `2022-01-11`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.398715+00`,
    fuelType: `diesel`,
    trim: `3`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `8817fb36-7ab2-11eb-9745-dff2577ddb56`,
    make: `Ford`,
    registrationNumber: `MW67YOL`,
    model: `Transit Connect 200 L1 Base`,
    onCoverDate: `2022-01-12`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.354271+00`,
    fuelType: `diesel`,
    trim: `200 L1 Base`,
    nominalStartYear: 2013,
    status: `on_cover`,
  },
  {
    vehicleId: `0a44aede-7abc-11eb-9745-1f9c73f1d26e`,
    make: `Peugeot`,
    registrationNumber: `OY19ETX`,
    model: `Partner Professional Standard`,
    onCoverDate: `2022-01-12`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.447306+00`,
    fuelType: `diesel`,
    trim: `Professional Standard`,
    nominalStartYear: 2018,
    status: `on_cover`,
  },
  {
    vehicleId: `c8d5360e-7abf-11eb-9745-fbab8384c4b7`,
    make: `Toyota`,
    registrationNumber: `FG21GVV`,
    model: `Corolla Hybrid Icon Tech`,
    onCoverDate: `2022-01-13`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.420975+00`,
    fuelType: `petrol`,
    trim: `Icon Tech`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `8afb1fa4-7ab2-11eb-9745-bf4e0f457c38`,
    make: `Ford`,
    registrationNumber: `BL18HNN`,
    model: `Transit Courier Trend`,
    onCoverDate: `2022-01-13`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.455437+00`,
    fuelType: `diesel`,
    trim: `Trend`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `ac679da6-7ab8-11eb-9745-3f62b6344ab8`,
    make: `Mercedes-Benz`,
    registrationNumber: `WR67HFS`,
    model: `Sprinter 314 MWB`,
    onCoverDate: `2022-01-13`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.378981+00`,
    fuelType: `diesel`,
    trim: `314 MWB`,
    nominalStartYear: 2013,
    status: `on_cover`,
  },
  {
    vehicleId: `d72bae9e-7ab6-11eb-9745-93a5217050f5`,
    make: `Kia`,
    registrationNumber: `PE71VZT`,
    model: `Sportage 2`,
    onCoverDate: `2022-01-14`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.457479+00`,
    fuelType: `diesel`,
    trim: `2`,
    nominalStartYear: 2018,
    status: `on_cover`,
  },
  {
    vehicleId: `e8deeb9c-7abb-11eb-9745-6fd4085e6676`,
    make: `Peugeot`,
    registrationNumber: `OE17JHU`,
    model: `Partner Professional L1`,
    onCoverDate: `2022-01-14`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.462788+00`,
    fuelType: `diesel`,
    trim: `Professional L1`,
    nominalStartYear: 2015,
    status: `on_cover`,
  },
  {
    vehicleId: `da8172cc-7ab6-11eb-9745-93db9416efd8`,
    make: `Kia`,
    registrationNumber: `FT21 CZV`,
    model: `Rio 3`,
    onCoverDate: `2022-01-15`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.324866+00`,
    fuelType: `petrol`,
    trim: `3`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `4ac45764-7abe-11eb-9745-63530b72509c`,
    make: `SEAT`,
    registrationNumber: `KS21 LLE`,
    model: `Ateca SE Technology`,
    onCoverDate: `2022-01-15`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.416856+00`,
    fuelType: `petrol`,
    trim: `SE Technology`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `8817fb36-7ab2-11eb-9745-dff2577ddb56`,
    make: `Ford`,
    registrationNumber: `MW67 YOM`,
    model: `Transit Connect 200 L1 Base`,
    onCoverDate: `2022-01-15`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.341147+00`,
    fuelType: `diesel`,
    trim: `200 L1 Base`,
    nominalStartYear: 2013,
    status: `on_cover`,
  },
  {
    vehicleId: `02fe7998-7abc-11eb-9745-f333bf12d084`,
    make: `Peugeot`,
    registrationNumber: `CN67 LCU`,
    model: `Boxer 335 L3 Chassis Cab`,
    onCoverDate: `2022-01-15`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.394433+00`,
    fuelType: `diesel`,
    trim: `335 L3 Chassis Cab`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `99e399ce-7ab2-11eb-9745-cb845fe0abdd`,
    make: `Ford`,
    registrationNumber: `HV18ENW`,
    model: `Transit Custom 270 L1H1 Limited`,
    onCoverDate: `2022-01-17`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.365724+00`,
    fuelType: `diesel`,
    trim: `270 L1H1 Limited`,
    nominalStartYear: 2012,
    status: `on_cover`,
  },
  {
    vehicleId: `048c77e8-7ab1-11eb-9745-f7291c24e861`,
    make: `Ducati`,
    registrationNumber: `OE17 JXH`,
    model: `SuperSport S`,
    onCoverDate: `2022-01-17`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.464936+00`,
    fuelType: `petrol`,
    trim: `S`,
    nominalStartYear: 2017,
    status: `on_cover`,
  },
  {
    vehicleId: `60d85be6-7abd-11eb-9745-fbd5bc301af6`,
    make: `Renault`,
    registrationNumber: `FX71DVK`,
    model: `Master LL35 Business`,
    onCoverDate: `2022-01-17`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.466927+00`,
    fuelType: `diesel`,
    trim: `LL35 Business`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `553a8bec-7ab3-11eb-9745-57148e39961c`,
    make: `Ford`,
    registrationNumber: `WT21LWA`,
    model: `Transit 350 Leader L3H1`,
    onCoverDate: `2022-01-17`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.431958+00`,
    fuelType: `diesel`,
    trim: `350 Leader L3H1`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `d978ab1a-7ac1-11eb-9745-a7901d4c3e5a`,
    make: `Volkswagen`,
    registrationNumber: `LJ19OJV`,
    model: `Transporter T32 Highline`,
    onCoverDate: `2022-01-17`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.469098+00`,
    fuelType: `diesel`,
    trim: `T32 Highline`,
    nominalStartYear: 2015,
    status: `on_cover`,
  },
  {
    vehicleId: `8afb1fa4-7ab2-11eb-9745-bf4e0f457c38`,
    make: `Ford`,
    registrationNumber: `BL18HVX`,
    model: `Transit Courier Trend`,
    onCoverDate: `2022-01-17`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.471144+00`,
    fuelType: `diesel`,
    trim: `Trend`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `e7aaa522-7abb-11eb-9745-a3d5a5bd689f`,
    make: `Peugeot`,
    registrationNumber: `CE68BGV`,
    model: `Boxer 435 L4H2 Professional`,
    onCoverDate: `2022-01-18`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.388855+00`,
    fuelType: `diesel`,
    trim: `435 L4H2 Professional`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `e8deeb9c-7abb-11eb-9745-6fd4085e6676`,
    make: `Peugeot`,
    registrationNumber: `OE17JHX`,
    model: `Partner Professional L1`,
    onCoverDate: `2022-01-18`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.358698+00`,
    fuelType: `diesel`,
    trim: `Professional L1`,
    nominalStartYear: 2015,
    status: `on_cover`,
  },
  {
    vehicleId: `d1bf16e4-7abb-11eb-9745-b353b90b6179`,
    make: `Peugeot`,
    registrationNumber: `OU64MPY`,
    model: `Boxer 335 L3H2 Professional`,
    onCoverDate: `2022-01-19`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.332063+00`,
    fuelType: `diesel`,
    trim: `335 L3H2 Professional`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `6624eb50-7abd-11eb-9745-5f6c1366cc71`,
    make: `Renault`,
    registrationNumber: `FL71UHZ`,
    model: `Trafic SL28 Sport`,
    onCoverDate: `2022-01-19`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.473431+00`,
    fuelType: `diesel`,
    trim: `SL28 Sport`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `60d85be6-7abd-11eb-9745-fbd5bc301af6`,
    make: `Renault`,
    registrationNumber: `FX71DVL`,
    model: `Master LL35 Business`,
    onCoverDate: `2022-01-20`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.475408+00`,
    fuelType: `diesel`,
    trim: `LL35 Business`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `aec0d47a-7aac-11eb-9745-d3d26b3ee039`,
    make: `AC`,
    registrationNumber: `AO70DAO`,
    model: `16 null`,
    onCoverDate: `2022-01-20`,
    offCoverDate: null,
    sentToMID: `2022-01-29 00:32:47.482032+00`,
    fuelType: `petrol`,
    trim: null,
    nominalStartYear: 1933,
    status: `on_cover`,
  },
  {
    vehicleId: `d1bf16e4-7abb-11eb-9745-b353b90b6179`,
    make: `Peugeot`,
    registrationNumber: `AX15NPK`,
    model: `Boxer 335 L3H2 Professional`,
    onCoverDate: `2022-01-31`,
    offCoverDate: `2022-03-24`,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `335 L3H2 Professional`,
    nominalStartYear: 2014,
    status: `off_cover`,
  },
  {
    vehicleId: `31f4f820-7aae-11eb-9745-ff904a95ec36`,
    make: `Audi`,
    registrationNumber: `YP70 GBX`,
    model: `Q2 S Line Black Edition`,
    onCoverDate: `2022-01-23`,
    offCoverDate: `2022-01-23`,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `S Line Black Edition`,
    nominalStartYear: 2016,
    status: `off_cover`,
  },
  {
    vehicleId: `da0439b2-7abe-11eb-9745-e33127896e82`,
    make: `Skoda`,
    registrationNumber: `ML20HJN`,
    model: `Karoq SportLine`,
    onCoverDate: `2022-02-08`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `SportLine`,
    nominalStartYear: 2017,
    status: `on_cover`,
  },
  {
    vehicleId: `e9774842-7aac-11eb-9745-f77f12eb5a30`,
    make: `Aston Martin`,
    registrationNumber: `ND07VZF`,
    model: `DB7 Vantage`,
    onCoverDate: `2022-02-17`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Vantage`,
    nominalStartYear: 2003,
    status: `on_cover`,
  },
  {
    vehicleId: `a4bcca1a-7ab6-11eb-9745-2305adb59cb2`,
    make: `Kia`,
    registrationNumber: `KM55APF`,
    model: `Sorento XT`,
    onCoverDate: `2022-02-18`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `XT`,
    nominalStartYear: 2006,
    status: `on_cover`,
  },
  {
    vehicleId: `d86d040e-7ab8-11eb-9745-b7c5d43613bf`,
    make: `Mercedes-Benz`,
    registrationNumber: `RE69 CEM`,
    model: `A Class A200 Sport Premium`,
    onCoverDate: `2022-02-18`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `A200 Sport Premium`,
    nominalStartYear: 2018,
    status: `on_cover`,
  },
  {
    vehicleId: `057d79ee-7ab7-11eb-9745-a7b152715b23`,
    make: `Lexus`,
    registrationNumber: `GU61 BKG`,
    model: `RX Hybrid 450h SE-I`,
    onCoverDate: `2022-02-24`,
    offCoverDate: `2022-05-26`,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `450h SE-I`,
    nominalStartYear: 2009,
    status: `on_cover`,
  },
  {
    vehicleId: `3019282e-7ab2-11eb-9745-078b904c2db7`,
    make: `Ford`,
    registrationNumber: `KF15NYD`,
    model: `C-Max Titanium`,
    onCoverDate: `2022-03-03`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Titanium`,
    nominalStartYear: 2011,
    status: `on_cover`,
  },
  {
    vehicleId: `a4adf208-7abe-11eb-9745-ef1330221481`,
    make: `Skoda`,
    registrationNumber: `BN66GGV`,
    model: `Octavia SE L`,
    onCoverDate: `2022-03-04`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `SE L`,
    nominalStartYear: 2013,
    status: `on_cover`,
  },
  {
    vehicleId: `7b5beb40-7aae-11eb-9745-9f70c8576228`,
    make: `Audi`,
    registrationNumber: `OV69ABC`,
    model: `A3 e-tron S Line Competition`,
    onCoverDate: `2022-03-25`,
    offCoverDate: `2022-04-07`,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `S Line Competition`,
    nominalStartYear: 2020,
    status: `off_cover`,
  },
  {
    vehicleId: `52ebb6b8-7ab3-11eb-9745-cb0d62cb71c6`,
    make: `Ford`,
    registrationNumber: `YP21 KYK`,
    model: `Ranger Wildtrak Double Cab`,
    onCoverDate: `2022-03-07`,
    offCoverDate: null,
    sentToMID: `2022-03-10 00:33:37.852853+00`,
    fuelType: `diesel`,
    trim: `Wildtrak Double Cab`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `75529a06-7ab2-11eb-9745-b3e1ba327de4`,
    make: `Ford`,
    registrationNumber: `YO18XFY`,
    model: `Mondeo Hybrid Vignale`,
    onCoverDate: `2022-04-01`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Vignale`,
    nominalStartYear: 2014,
    status: `on_cover`,
  },
  {
    vehicleId: `7be98aaa-7aad-11eb-9745-ffcacacf3ea1`,
    make: `Audi`,
    registrationNumber: `LM55APP`,
    model: `A3 Black Edition`,
    onCoverDate: `2022-04-06`,
    offCoverDate: `2022-04-08`,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Black Edition`,
    nominalStartYear: 2008,
    status: `off_cover`,
  },
  {
    vehicleId: `c26c4c96-7ab8-11eb-9745-07ed659388db`,
    make: `Mercedes-Benz`,
    registrationNumber: `DJ71RZP`,
    model: `280 CE`,
    onCoverDate: `2022-04-06`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `CE`,
    nominalStartYear: 1968,
    status: `on_cover`,
  },
  {
    vehicleId: `d09951c8-1a2d-11ec-8f69-df200c458c8f`,
    make: `Bentley`,
    registrationNumber: `KM55APP`,
    model: `Bentayga PHEV Hybrid`,
    onCoverDate: `2022-04-06`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Hybrid`,
    nominalStartYear: 2019,
    status: `on_cover`,
  },
  {
    vehicleId: `6b84cc96-7abd-11eb-9745-ab07cf054969`,
    make: `Renault`,
    registrationNumber: `WP70CKN`,
    model: `ZOE i GT Line Rapid Charge`,
    onCoverDate: `2022-04-06`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `electric`,
    trim: `i GT Line Rapid Charge`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `6b84cc96-7abd-11eb-9745-ab07cf054969`,
    make: `Renault`,
    registrationNumber: `WP70CLN`,
    model: `ZOE i GT Line Rapid Charge`,
    onCoverDate: `2022-04-06`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `electric`,
    trim: `i GT Line Rapid Charge`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `c3a85c36-7aad-11eb-9745-abb01b2d6303`,
    make: `Audi`,
    registrationNumber: `WP70CKQ`,
    model: `A3 Quattro Sport`,
    onCoverDate: `2022-04-06`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `Quattro Sport`,
    nominalStartYear: 2008,
    status: `on_cover`,
  },
  {
    vehicleId: `126675a0-7ab9-11eb-9745-0bc64bfcbe49`,
    make: `Mercedes-Benz`,
    registrationNumber: `WP70CKP`,
    model: `307D High Roof `,
    onCoverDate: `2022-04-06`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `diesel`,
    trim: `High Roof `,
    nominalStartYear: 1977,
    status: `on_cover`,
  },
  {
    vehicleId: `527801e2-7abc-11eb-9745-af636624f2cc`,
    make: `Peugeot`,
    registrationNumber: `EO17BLE`,
    model: `3008 GT`,
    onCoverDate: `2022-04-06`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `GT`,
    nominalStartYear: 2020,
    status: `on_cover`,
  },
  {
    vehicleId: `8124d9b6-7ac1-11eb-9745-e72dac3d4ec8`,
    make: `Volkswagen`,
    registrationNumber: `NV09XAS`,
    model: `Golf S`,
    onCoverDate: `2022-04-07`,
    offCoverDate: null,
    sentToMID: null,
    fuelType: `petrol`,
    trim: `S`,
    nominalStartYear: 2009,
    status: `on_cover`,
  },
]

export const mockFleetEntries = generateFleetEntries(
  entries.map((it) => ({
    ...it,
  }))
)

export const mockFleetStats: FleetStats = {
  totalVehicles: 10,
  scheduledTotal: 1,
  scheduledPercent: 10,
  onCoverTotal: 2,
  onCoverPercent: 20,
  offCoverTotal: 8,
  offCoverPercent: 80,
  connectivityRatio: null,
  connectedVrns: [],
}
